import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import classNames from 'classnames';

import { Field } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import TextField from 'components/fields/TextField';
import Tooltip from 'components/common/Tooltip';
import Menu from 'components/common/Menu';
import IconButton from 'components/common/IconButton';
import IconSplit from 'components/icons/IconSplit';
import IconLink from 'components/icons/IconLink';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

import ProductClaimSplitForClaimForm from './ProductClaimSplitForClaimForm';

const styles = theme => ({
  root: {
    maxWidth: 70,
    flexBasis: 70,
  },
  rootWithCaloric: {
    maxWidth: 140,
    flexBasis: 140,
  },
  container: {
    position: 'relative',
  },
  iconButton: {
    position: 'absolute',
    width: 36,
    height: 36,
    top: '-50%',
    marginLeft: -6,
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      right: 12,
      left: 12,
      bottom: 16,
      height: 2,
      backgroundColor: theme.palette.common.white,
      zIndex: -1,
    },
  },
  iconSplit: {
    width: 16,
    height: 16,
  },
  tooltipLink: {
    position: 'absolute',
    left: '50%',
    top: 20,
    marginLeft: -12,
    zIndex: 1,
    '&:before': {
      display: 'block',
      content: '""',
      position: 'absolute',
      zIndex: 1,
      top: 4,
      bottom: 4,
      left: 0,
      right: 0,
      backgroundColor: theme.palette.common.white,
      borderRadius: 8,
    },
  },
  iconLink: {
    display: 'block',
    position: 'relative',
    zIndex: 2,
    width: 24,
    height: 24,
    color: theme.palette.primary[500],
  },
});

class ProductClaimUnitsSplitForClaimFields extends Component {
  constructor(props) {
    super(props);
    const units = get(props, `${props.name}.Units`);
    const caloriesPerUnit = get(props, `${props.name}.Calories Per Unit`);
    this.state = {
      anchorEl: null,
      caloricValue: units.input.value && caloriesPerUnit.input.value ? Math.ceil(units.input.value * caloriesPerUnit.input.value / 100) : '',
      caloricFocused: false,
      caloricTouched: false,
    };

    this.onButtonClick = this.onButtonClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onCaloricFocus = this.onCaloricFocus.bind(this);
    this.onCaloricBlur = this.onCaloricBlur.bind(this);
    this.onCaloricChange = this.onCaloricChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const units = get(this.props, `${this.props.name}.Units`);
    const nextCaloriesPerUnit = get(nextProps, `${nextProps.name}.Calories Per Unit`);
    const nextUnits = get(nextProps, `${nextProps.name}.Units`);
    if (!this.state.caloricFocused && nextCaloriesPerUnit.input.value && nextUnits.input.value !== units.input.value) {
      this.setState({
        caloricValue: nextUnits.input.value ? Math.ceil(nextUnits.input.value * nextCaloriesPerUnit.input.value / 100) : '',
        caloricTouched: true,
      });
    }
  }

  onButtonClick(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onCaloricFocus() {
    this.setState({
      caloricFocused: true,
      caloricTouched: true,
    });
  }

  onCaloricBlur() {
    const units = get(this.props, `${this.props.name}.Units`);
    const caloriesPerUnit = get(this.props, `${this.props.name}.Calories Per Unit`);
    this.setState({
      caloricFocused: false,
      caloricValue: units.input.value ? Math.ceil(units.input.value * caloriesPerUnit.input.value / 100) : '',
    });
  }

  onCaloricChange(event) {
    const units = get(this.props, `${this.props.name}.Units`);
    const caloriesPerUnit = get(this.props, `${this.props.name}.Calories Per Unit`);
    if (caloriesPerUnit && caloriesPerUnit.input.value) {
      const newUnitsValue = Math.round((event.target.value * 100) / caloriesPerUnit.input.value);
      this.setState({
        caloricValue: event.target.value
      });
      units.input.onChange(newUnitsValue === 0 ? 1 : newUnitsValue);
    }
  }

  render() {
    const { name, systemSettings, onFieldFocus, onFieldBlur, disabled, classes, ...fields } = this.props;
    const { anchorEl, caloricValue, caloricTouched } = this.state;
    const units = get(fields, `${name}.Units`);
    const splitForClaim = get(fields, `${name}.Split for Claim`);
    const caloriesPerUnit = get(fields, `${name}.Calories Per Unit`);
    return (
      <Grid
        className={classNames(classes.root, {
          [classes.rootWithCaloric]: caloriesPerUnit && caloriesPerUnit.input.value,
        })}
        item
      >
        <Grid
          className={classes.container}
          container
          justify="flex-start"
          wrap="nowrap"
          spacing={8}
        > 
          <Grid item xs={caloriesPerUnit && caloriesPerUnit.input.value ? 6 : 12}>
            <Field
              id={`${name}.Units`}
              name={`${name}.Units`}
              label={(
                <span>
                  Units
                  {systemSettings
                    && systemSettings['System Config']
                    && systemSettings['System Config'].SPLIT_FOR_CLAIM_MINIMUM_UNITS
                    && Number(units.input.value) >= systemSettings['System Config'].SPLIT_FOR_CLAIM_MINIMUM_UNITS
                    && (
                      <IconButton
                        aria-label="Split order line"
                        aria-owns={anchorEl ? `${name}-split-for-claim-menu` : null}
                        aria-haspopup="true"
                        className={classes.iconButton}
                        onClick={this.onButtonClick}
                        tooltipContent="Split order line"
                        disabled={disabled}
                      >
                        <IconSplit className={classes.iconSplit} />
                      </IconButton>
                    )}
                </span>
              )}
              labelOverlap
              component={TextField}
              validate={[validate.required]}
              normalize={normalize.positiveNumber}
              fullWidth
              onFocus={event => onFieldFocus({
                Units: event.target.value,
              })}
              onBlur={(event) => {
                if (event.target.value) {
                  onFieldBlur({
                    Units: event.target.value,
                  });
                }
              }} 
              disabled={disabled}
            />
          </Grid>
          {caloriesPerUnit.input.value &&
            <Fragment>
              <Tooltip
                className={classes.tooltipLink}
                content="This product is managed in caloric units - they will be sent in claims, printed in documents, calculated in total charge"
                placement="bottom"
                color="dark"
                disableGutters
              >
                <IconLink className={classes.iconLink} />
              </Tooltip>
              <Grid item xs={6}>
                <TextField
                  id={`${name}.Cal Units`}
                  name={`${name}.Cal Units`}
                  label="Cal Units"
                  labelOverlap
                  input={{
                    value: caloricValue,
                    name: `${name}.Cal Units`,
                    onChange: this.onCaloricChange,
                    onFocus: this.onCaloricFocus,
                    onBlur: this.onCaloricBlur,
                  }}
                  meta={{
                    touched: caloricTouched,
                    error: caloricValue.length === 0 ? 'Field is required' : null,
                  }}
                  normalize={normalize.positiveNumber}
                  fullWidth
                  disabled={disabled}
                />
              </Grid>
            </Fragment>
          }
          <Menu
            id={`${name}-split-for-claim-menu`}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.onMenuClose}
            placement="top-middle"
            list={false}
          >
            <ProductClaimSplitForClaimForm
              form={`${name}-splitForClaimForm`}
              initialValues={{
                'Split for Claim': splitForClaim.input.value || 1,
              }}
              onSubmitSuccess={(values) => {
                this.onMenuClose();
                splitForClaim.input.onChange(values['Split for Claim']);
              }}
            />
          </Menu>
        </Grid>
      </Grid>
    );
  }
}

ProductClaimUnitsSplitForClaimFields.propTypes = {
  name: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  systemSettings: PropTypes.object.isRequired,
  onFieldFocus: PropTypes.func.isRequired,
  onFieldBlur: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  classes: PropTypes.shape({
    iconButton: PropTypes.string.isRequired,
    iconSplit: PropTypes.string.isRequired,
  }).isRequired,
};

ProductClaimUnitsSplitForClaimFields.defaultProps = {
  disabled: false,
};

export default withStyles(styles)(ProductClaimUnitsSplitForClaimFields);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaim/ProductClaimUnitsSplitForClaimFields.js